/**
 * Returns the last element in a given array.
 */
export const getLastArrayElement = (array) => {
    return array[array.length - 1];
};
//# sourceMappingURL=get-last-array-element.js.map